import React from "react";
import Skeleton from "react-loading-skeleton";
import useScreenBreakpoint from "@hooks/useScreenBreakpoint";
import { SkeletonContainer } from "./styles";

type LawsuitTrackerLineSkeletonProps = {
  height: number;
  offset?: number;
};

const LawsuitTrackerLineSkeleton: React.FC<LawsuitTrackerLineSkeletonProps> = ({
  height,
  offset = 15,
}) => {
  const { isSmallerScreens } = useScreenBreakpoint();
  const LEGEND_HEIGHT = isSmallerScreens ? 100 : 50;
  const GAP = 24;
  const CHART_HEIGHT = height + offset - GAP - LEGEND_HEIGHT;
  return (
    <SkeletonContainer>
      <Skeleton height={CHART_HEIGHT} />
      <Skeleton height={LEGEND_HEIGHT} />
    </SkeletonContainer>
  );
};

export default LawsuitTrackerLineSkeleton;
